import { openModal } from '@core/components/ModalStack';
import { OrganizationOverlayProps } from './OrganizationOverlay';

export async function openOrganizationOverlay(props: OrganizationOverlayProps) {
  const { OrganizationOverlay } = await import('./OrganizationOverlay');

  openModal(OrganizationOverlay, props);
}
